const ORIGIN = window.location.origin

const getHome = (): URL => {
	const url = new URL(ORIGIN)
	return url
}

const getWpRest = (): URL => {
	const url = new URL('http://biolayne.test')
	url.pathname = '/wp-json/biolayne-app/v1';
	return url
}

const getWpRestAzure = (): URL => {
	const url = getHome()
	url.pathname = '/api'
	return url
}

export const appUrls: Record<string, URL> = {
	home: getHome(),
	api: getWpRest(),
	azure_api: getWpRestAzure(),
}
